import React, { useState, useEffect } from "react";
import instance from "../../instance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "../Customer.css";

const openConfirmPhone = (phones) => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <ConfirmDialog phones={phones} onClose={onClose} />
    ),
  });
};

const ConfirmDialog = ({ phones, onClose }) => {
  const [message, setMessage] = useState("");
  const [language, setLanguage] = useState("ar");
  const [charCount, setCharCount] = useState(0);
  const [messageCount, setMessageCount] = useState(1);

  const MAX_CHARS_PER_MESSAGE = 70; // Maximum characters per message

  const handleMessageChange = (e) => {
    const text = e.target.value;
    setMessage(text);
    setCharCount(text.length);
    setMessageCount(Math.ceil(text.length / MAX_CHARS_PER_MESSAGE));
  };

  const handleSendSms = async (phones, message) => {
    try {
      const res = await instance.post("sms/number-sms", {
        phones: phones,
        message: message,
      });

      if (res.status === 200) {
        toast.success(`Successfully sent ${messageCount} message(s)`);
      } else {
        console.error("Error sending SMS:", res.statusText);
        toast.error("An error occurred while sending the messages");
      }
    } catch (err) {
      console.error("Error sending SMS:", err);
      toast.error("An error occurred while sending the messages");
    }
  };

  useEffect(() => {
    const textarea = document.querySelector(".textar");
    if (language === "ar") {
      textarea.style.direction = "rtl";
      textarea.style.textAlign = "right";
    } else {
      textarea.style.direction = "ltr";
      textarea.style.textAlign = "left";
    }
  }, [language]);

  const placeholderText =
    language === "ar" ? "اكتب رسالتك هنا" : "Type your message here";

  return (
    <div className="custom-ui">
      <h1>Confirm SMS Sending</h1>
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="language-select"
      >
        <option value="ar">Ar</option>
        <option value="en">En</option>
      </select>

      <textarea
        placeholder={placeholderText}
        onChange={handleMessageChange}
        className="textar"
        value={message}
      />
      <div>
        Characters: {charCount} / Messages: {messageCount}
      </div>
      <button
        onClick={() => {
          handleSendSms(phones, message);
          onClose();
        }}
        disabled={message.trim().length === 0}
      >
        Send
      </button>
      <button onClick={onClose}>Cancel</button>
    </div>
  );
};

export { openConfirmPhone };
